export const validateName = (v: string) => {
  const errors = []
  if (v === '') {
    errors.push('必須項目です。入力してください。')
  } else if (!validateCharacters(v)) {
    errors.push('機種依存文字など入力できない文字が含まれています。')
  }
  return errors
}

export const validateEmail = (v: string, shouldCheckFormat: boolean) => {
  const errors = []
  if (
    v === '' ||
    !validateCharacters(v) ||
    (shouldCheckFormat && !validateEmailFormat(v))
  ) {
    errors.push('必須項目です。メールアドレスの形式で入力してください。')
  }
  return errors
}

export const validatePhone = (v: string) => {
  const errors = []
  if (v === '') {
    errors.push('必須項目です。半角数字で入力してください。')
  } else if (!validatePhoneFormat(v)) {
    errors.push('半角数字11文字以内で入力してください。')
  }
  return errors
}

// 機種依存文字が使われていないか
const validateCharacters = (v: string) => {
  // \p{Script=Latin}: ラテン文字（英字など）
  // \p{Script=Hiragana}: ひらがな
  // \p{Script=Katakana}: カタカナ
  // \uFF65-\uFF9F: 半角カタカナ
  // \p{Script=Han}: 漢字 (CJK の範囲)
  // 0-9: 数字
  // ０-９ : 全角数字
  // \uFF01-\uFF60: 全角の記号, 全角の大文字および小文字英字
  // !-/: ASCII の記号の範囲 1
  // :-@: ASCII の記号の範囲 2
  // [-`]: ASCII の記号の範囲 3
  // {-~}: ASCII の記号の範囲 4
  // ー: 長音
  // ―: ダッシュ
  // \u0020: 半角スペース
  // \u3000: 全角スペース
  // それ以降: 上記範囲から漏れている記号
  const regex =
    /^[\p{Script=Latin}\p{Script=Hiragana}\p{Script=Katakana}\uFF65-\uFF9F\p{Script=Han}0-9０-９\uFF01-\uFF60!-/:<-@[-`{-~}ー―\u0020\u3000、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～〜∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓∈∋⊆⊇⊂⊃∪∩∧∨￢⇒⇔∀∃∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬Å‰♯♭♪†‡¶◯;]+$/u
  return regex.test(v)
}

const validateEmailFormat = (v: string) => {
  // Marketo側のバリデーションにかかってしまうと画面遷移ができなくなってしまうので、ブラウザのデフォルトのバリデーションロジックをベースにしている
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#validation
  // ドメインがないとMarketoでエラーになってしまうので「.」以降を必須に変更している
  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
  return regex.test(v)
}

const validatePhoneFormat = (v: string) => {
  const regex = /^\d{1,11}$/
  return regex.test(v)
}
